// Angular
import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
// 3rd libraries
import { NgxUiLoaderService } from 'ngx-ui-loader';
// Local services
import { AlertService } from '../../services/alert.service';
import { RoleService } from './role.service';
// Messages
import { GlobalMessages } from '../../utils/messages';
import { Messages } from './messages';
// Rxjs
import { Subscription } from 'rxjs';
// Common functions
import { CommonFunctions } from '../../utils/common-functions';

@Component({
  selector: 'app-seguridad-creacion-rol',
  templateUrl: './seguridad-creacion-rol.component.html',
  styleUrls: ['./seguridad-creacion-rol.component.scss']
})

export class SeguridadCreacionRolComponent implements OnInit, OnDestroy {
  @Output() selecttab = new EventEmitter<any>();
  data = [];
  // Reactive forms
  isEdit = false;
  roleDescription = '';
  roleForm: FormGroup;
  roleId = 0;
  roleName = '';
  // Rxjs
  subscription: Subscription;
  constructor(
    private alertService: AlertService,
    private formBuilder: FormBuilder,
    private loaderService: NgxUiLoaderService,
    private roleService: RoleService,
    private router: Router,
  ) {
    this.subscription = this.roleService.editRole.subscribe(data => {
      if (data.edit === true) {
        this.isEdit = true;
        this.roleName = data.nombre;
        this.roleDescription = data.descripcion;
        this.roleId = data.id_rol;
      }
    });
  }

  async ngOnInit() {
    this.roleForm = this.formBuilder.group({
      roleName: [this.roleName, Validators.required],
      roleDescription: [this.roleDescription, Validators.required],
    });
    await this.getModule();
  }

  ngOnDestroy(): void {
    this.roleName = '';
    this.roleDescription = '';
    this.roleId = 0;
    this.isEdit = false;
    this.roleService.setRole({
      edit: false,
    });
    this.subscription.unsubscribe();
  }

  changeMenuModule(tab): void {
    this.selecttab.emit(tab);
  }

  autoCompleteEdit(role: any): void {
    this.roleId = role.id_rol;
    this.roleForm.controls.roleName.setValue(role.nombre);
    this.roleForm.controls.roleDescription.setValue( role.descripcion);
  }

  async createRole() {
    this.loaderService.startLoader('loader-global', 'loadingDashboard');
    const modules = [];
    const permissions = [];
    let emptyPermission = true;

    this.data.forEach(module => {
      const itemModule = {
        idRolModulo: 0,
        idRol: 0,
        idModulo: module.moduleId,
        active: true,
      };
      modules.push(itemModule);
      if (module.permissions.length > 0) {
        module.permissions.forEach(permission => {
          if (permission.checked === true) {
            emptyPermission = false;
          }
          const itemPermission = {
            idRolPermiso: 0,
            idPermiso: permission.permissionId,
            idRol: 0,
            activo: permission.checked,
          };
          permissions.push(itemPermission);
        });
      }
    });

    if (emptyPermission === true) {
      this.alertService.show(
        GlobalMessages.GENERAL_ERROR_TITLE,
        Messages.EMPTY_PERMISSIONS,
      ).then();
      this.loaderService.stopLoader('loader-global', 'loadingDashboard');
      return;
    }

    const result = await this.roleService.createRole({
      id_rol: 0,
      nombre: this.roleForm.controls.roleName.value,
      descripcion: this.roleForm.controls.roleDescription.value,
      activo: true,
      rolModulo: modules,
      rolPermiso: permissions,
    });

    if (result.codigo === 1) {
      this.loaderService.stopLoader('loader-global', 'loadingDashboard');
      await this.alertService.show(
        GlobalMessages.NOTE_TITLE,
        Messages.ROLE_CREATE_SUCCESS,
      );
      this.router.navigate(['/modulo-seguridad/', 'seguridad', 'listado-roles']);
      this.changeMenuModule('listado-roles');
    } else {
      await this.alertService.show(
        GlobalMessages.GENERAL_ERROR_TITLE,
        GlobalMessages.GENERAL_ERROR_BODY,
      );
      this.loaderService.stopLoader('loader-global', 'loadingDashboard');
    }

    this.loaderService.stopLoader('loader-global', 'loadingDashboard');
  }

  async getModule() {
    this.loaderService.startLoader('loader-global', 'loadingDashboard');
    const data = [];
    const result =  await this.roleService.getModules();
    if (result) {
      const modules = result.Respuesta;
      if (modules.length > 0 && result.codigo === 1) {
        modules.forEach(module => {
          const item: any = {};
          item.moduleId = module.id_modulo;
          item.filterAll = false;
          item.moduleName = module.nombre;
          item.moduleDescription = module.descripcion;
          item.permissions = [];
          data.push(item);
        });
      } else {
       this.loaderService.stopLoader('loader-global', 'loadingDashboard');
       await this.alertService.show(
          GlobalMessages.GENERAL_ERROR_TITLE,
          GlobalMessages.GENERAL_ERROR_BODY,
        );
      }
    }

    if (data.length > 0) {
      await CommonFunctions.asyncForEach(data, async (itemModule) => {
        const resultPermissions =  await this.roleService.getPermissionsByModule({
            pIdModulo: itemModule.moduleId,
          });

        const permissions = resultPermissions.Respuesta;
        if (resultPermissions && resultPermissions.codigo === 1) {
          if (permissions.length > 0) {
            await CommonFunctions.asyncForEach(permissions, async (permission) => {
              if (itemModule.moduleId === permission.id_modulo) {
                const itemPermission: any = {};
                itemPermission.permissionId = permission.id_permiso;
                itemPermission.rolePermissionId = 0;
                itemPermission.permissionName = permission.nombre;
                itemPermission.checked = false;
                itemModule.permissions.push(itemPermission);
              }
            });
          }
        } else {
          await this.alertService.show(
            GlobalMessages.GENERAL_ERROR_TITLE,
            GlobalMessages.GENERAL_ERROR_BODY,
          );
        }
      });
    }
    this.data = data;
    this.loaderService.stopLoader('loader-global', 'loadingDashboard');

    if (this.roleId !== 0 && this.isEdit === true) {
      await this.getPermissionsByRole();
    }
  }

  selectAllPermissions(activate: any, moduleId: any): void {
    const module = this.data.find(item => item.moduleId === moduleId);
    if (module) {
      if (activate) {
        module.filterAll = true;
        module.permissions.forEach(permission => {
          permission.checked = true;
        });
      } else {
        module.filterAll = false;
        module.permissions.forEach(permission => {
          permission.checked = false;
        });
      }
    }
  }

  verifyAllChecked(moduleId: any) {
    const module = this.data.find(item => item.moduleId === moduleId);
    let isAllChecked = true;
    if (module &&  module.permissions.length > 0) {
      module.permissions.forEach(permission => {
        if (!permission.checked && isAllChecked ) {
          isAllChecked = false;
        }
      });
      module.filterAll = isAllChecked;
    }
  }

  async getPermissionsByRole() {
    this.loaderService.startLoader('loader-global', 'loadingDashboard');
    const result = await this.roleService.getPermissionsByRole(this.roleId);
    if (result && result.codigo === 1) {
      const permissions = result.Respuesta;
      if (permissions.length > 0) {
        permissions.forEach(permission => {
          this.data.forEach(module => {
            module.permissions.forEach(itemPermission => {
              if (permission.id_permiso === itemPermission.permissionId) {
                itemPermission.rolePermissionId = permission.id_rol_permiso;
                itemPermission.checked = permission.activo;
              }
            });
          });
        });
      }
      this.loaderService.stopLoader('loader-global', 'loadingDashboard');
      } else {
        this.alertService.show(
          GlobalMessages.GENERAL_ERROR_TITLE,
          GlobalMessages.GENERAL_ERROR_BODY,
        ).then();
        this.loaderService.stopLoader('loader-global', 'loadingDashboard');
      }
  }

  async updateRolePermission(rolePermissionId: any, active: any) {
    this.loaderService.startLoader('loader-global', 'loadingDashboard');
    const result = await this.roleService.updatePermissionRole({
      idRolPermiso: rolePermissionId,
      activo: active,
    });

    if (result.codigo === 1) {
      await this.getModule();
      this.loaderService.stopLoader('loader-global', 'loadingDashboard');
    } else {
      await this.alertService.show(
        GlobalMessages.GENERAL_ERROR_TITLE,
        GlobalMessages.GENERAL_ERROR_BODY,
      );
    }
  }

  async updateRole() {
    this.loaderService.startLoader('loader-global', 'loadingDashboard');
    const result = await this.roleService.updateRole({
      id_rol: this.roleId,
      nombre: this.roleForm.controls.roleName.value,
      descripcion: this.roleForm.controls.roleDescription.value,
      activo: true,
    });
    if (result && result.codigo === 1) {
      this.loaderService.stopLoader('loader-global', 'loadingDashboard');
      await this.alertService.show(
        GlobalMessages.NOTE_TITLE,
        Messages.UPDATE_ROLE_SUCCESS,
      );
      this.router.navigate(['/modulo-seguridad/', 'seguridad', 'listado-roles']);
      this.changeMenuModule('listado-roles');
    } else {
      await this.alertService.show(
        GlobalMessages.GENERAL_ERROR_TITLE,
        GlobalMessages.GENERAL_ERROR_BODY,
      );
      this.loaderService.stopLoader('loader-global', 'loadingDashboard');
    }
  }

}
